// extracted by mini-css-extract-plugin
export var borderRadius = "_e3-4";
export var large = "_e3-3";
export var logoContainer = "_e3-0";
export var nameLogo = "_e3-2";
export var small = "_e3-1";